import { useQuery } from "@tanstack/react-query";
import useApi from "../../../../../shared/hooks/useApi";
import type { CaregiverProfileCaregiver } from "../../../caregiverProfileModal.types";

export function useCaregiverAssociatedPatients(caregiverId: CaregiverProfileCaregiver["id"]) {
  const { api } = useApi();

  return useQuery({
    queryKey: ["caregiverProfileModal", caregiverId, "patients"],
    queryFn: () =>
      api.get("./caregiver/:caregiverId/patients_associated", {
        path: { caregiverId },
      }),
  });
}
